@Controller('ib-subscription-models-configuration-form-module',
    ['$uibModalInstance', 'object'], [])
class ibModalConditionsController implements ng.IController {
    public model: any;
    constructor (private $uibModalInstance:ng.ui.bootstrap.IModalInstanceService,
        private object: object) {
        this.model = this.object;
    }

    close =():void => {
        this.$uibModalInstance.dismiss();
    };

    accept = ():void  => {
        this.$uibModalInstance.close();
    };
}
